import * as React from 'react'

function SvgCiti(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="60"
      height="35"
      viewBox="0 0 60 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.612 14.2428H26.4212V29.6967H29.612V14.2428ZM32.4984 14.2428V17.1223H35.2327V25.8337C35.2327 27.0469 35.4609 28.0313 36.1447 28.7891C36.8286 29.4701 37.6646 29.8495 38.7278 29.9243C39.8672 29.9243 40.7782 29.6967 41.5371 29.1675L42.297 26.4408V26.2132L42.1458 26.288C41.3109 26.8192 40.551 27.1217 39.7911 27.1217C38.8039 27.1217 38.3484 26.5146 38.3484 25.3784V17.1213H41.5381V14.2428H38.3484V9.46924L35.2327 11.0608V14.2428H32.4984ZM47.8436 14.2428H44.6528V29.6967H47.8436V14.2428ZM19.1276 14.0152C16.8489 14.0152 14.9497 14.6222 13.4298 16.06C11.7599 17.4997 11 19.4696 11 21.9698C11 24.394 11.7599 26.4398 13.4298 27.8796C14.9497 29.3183 16.8489 30.0002 19.1276 30.0002C21.2551 30.0002 23.0793 29.0906 24.5971 27.3494V27.2735L22.85 25.1528L22.7749 25.2287C21.6356 26.3639 20.4202 26.97 18.9775 26.97C17.6088 26.97 16.4695 26.5157 15.5584 25.5312C14.6463 24.6216 14.1908 23.4854 14.1908 21.9698C14.1908 20.531 14.6463 19.3179 15.5584 18.4093C16.4695 17.4238 17.6088 17.0454 18.9775 17.0454C20.4202 17.0454 21.6356 17.5756 22.7749 18.7118L22.85 18.7877L24.5971 16.667V16.5911C23.0793 14.8489 21.2551 14.0152 19.1276 14.0152Z"
        fill="#1C4882"
      />
      <path
        d="M28.0184 11.7415C30.5254 9.09061 33.564 7.80262 37.1342 7.80262C40.6273 7.80262 43.668 9.09061 46.0978 11.7415H49.8192L49.7441 11.5138C48.3014 9.46901 46.4012 7.95336 44.1225 6.74228C41.9188 5.53017 39.5641 5 37.1342 5C34.6272 5 32.2714 5.53017 30.0688 6.74228C27.7891 7.95439 25.966 9.46901 24.5223 11.5138L24.3711 11.7415H28.0184Z"
        fill="#CF4037"
      />
    </svg>
  )
}

export default SvgCiti
